import { refreshCredentials } from "../../utils/securityUtil";
import { printTemplate } from "../../persistence/s3";

const config = {
	persistence: {
		type: "ambifi",
		refreshCredentials: refreshCredentials,
		printTemplate 
	}
};

export default config;